

<div class="row my-profile custom-zero-margin">
  <div class="col-md-12 tabcontent-display-line">
    <div class="row custom-bottom-border custom-last-child-margin">
      <div class="col-md-12">
        <h5 class="tabcontent-display-line-section-heading">
          {{ "myProfile.personalDetail" | cxTranslate }}
        </h5>
      </div>
    </div>
    <form [formGroup]="personaldetail">
      <div class="row">
        <div class="col-6" *ngIf="userTypes">
          <label class="tabcontent-display-line-label margin-top-label">{{
            "myProfile.fstNameLabel" | cxTranslate
          }}</label>
          <input
            [readonly]="true"
            class="tabcontent-display-line-data"
            [(ngModel)]="userTypes.firstName"
            formControlName="fname"
          />
        </div>

        <div class="col-6" *ngIf="userTypes">
          <label class="tabcontent-display-line-label margin-top-label">{{
            "myProfile.lastNameLabel" | cxTranslate
          }}</label>
          <input
            [readonly]="true"
            class="tabcontent-display-line-data"
            [(ngModel)]="userTypes.lastName"
            formControlName="lname"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-6" *ngIf="userTypes">
          <label class="tabcontent-display-line-label">{{
            "myProfile.signOnLabel" | cxTranslate
          }}</label>
          <input
            [readonly]="true"
            class="tabcontent-display-line-data email-input"
            formControlName="ssoid"
            [(ngModel)]="userTypes.uid"
          />
        </div>

        <div class="col-6" *ngIf="userTypes">
          <label class="tabcontent-display-line-label">{{
            "myProfile.emailLabel" | cxTranslate
          }}</label>
          <input
            [readonly]="true"
            class="tabcontent-display-line-data email-input email-lowercase"
            formControlName="email"
            [(ngModel)]="userTypes.email"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-6" *ngIf="userTypes">
          <label class="tabcontent-display-line-label">{{
            "myProfile.lastLoginLabel" | cxTranslate
          }}</label>
          <input
            [readonly]="true"
            class="tabcontent-display-line-data email-input"
            [(ngModel)]="userTypes.lastLogin"
            formControlName="lastlogin"
          />
        </div>

        <div class="col-6" *ngIf="userTypes"></div>
      </div>

      <div class="row">
        <div class="col-6" *ngIf="userTypes">
          <label class="tabcontent-display-line-label">{{
            "myProfile.roleLabel" | cxTranslate
          }}</label>
          <div *ngFor="let levels of userTypes.roles">
            <input
              [readonly]="true"
              class="tabcontent-display-line-data email-input"
              [(ngModel)]="userTypes.roles"
              formControlName="roleform"
            />
          </div>
        </div>

        <div class="col-6" *ngIf="userTypes"></div>
      </div>

      <div *ngIf="userTypes" class="unsure-block">
        <a class="unsure-link" (click)="displayRolesOverlay()">{{ "myProfile.unsure" | cxTranslate }}</a>
      </div>

      <div class="role-change-container">
        <div *ngIf="userTypes && showDiv">
          <button
            class="vs-tertiary-btn custom-btn"
            (click)="displayRoleChange()"
          >
          {{ "myProfile.roleChange" | cxTranslate }}
          </button>
        </div>

        <div *ngIf="userTypes && requestRoleChange">
          <div class="row">
            <div class="col-6" *ngIf="showDiv">
              <div>
                <label
                  class="tabcontent-display-line-label reqRoleChangeTitle"
                  >{{ "myProfile.newRole" | cxTranslate }}</label
                >

                <ng-select
                  class="role-dropdown"
                  formControlName="userRoles"
                  name="userRoles"
                  [(ngModel)]="userRoleModel"
                  [searchable]="false"
                  [clearable]="false"
                  placeholder='{{ "myProfile.selectPlaceholder" | cxTranslate }}'
                >
                  <ng-option
                    *ngFor="let access of userTypes.requestForRoleChange"
                    [value]="access"
                  >
                    {{ access }}
                  </ng-option>
                </ng-select>

                <div class="vs-text-area">
                  <textarea
                    placeholder='{{ "myProfile.commentsPlaceholder" | cxTranslate }}'
                    [(ngModel)]="comment"
                    formControlName="reqcomment"
                    maxlength="255"
                    class="custom-textbox tabcontent-display-line-data"
                  ></textarea>
                </div>

                <div class="row" *ngIf="showDiv">
                  <div>
                    <button
                      type="submit"
                      (click)="getRoleChange()"
                      class="vs-primary-btn submitbtn"
                    >
                      {{ "myProfile.submitBtn" | cxTranslate }}
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
